import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=8d5d1fc0&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=8d5d1fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5d1fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d5d1fc0')) {
      api.createRecord('8d5d1fc0', component.options)
    } else {
      api.reload('8d5d1fc0', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=8d5d1fc0&scoped=true&", function () {
      api.rerender('8d5d1fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/SapphireToggle/Button.vue"
export default component.exports